<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import '@styles/global.css'
import '@styles/map.css'

export default {
  name: 'App'
}
</script>

<style  lang="less">
#app{
  width:100%;
  height:100%;
}

</style>
